import { inject, injectable } from "@launchtray/tsyringe-async";
import { ForceRotateFactory, GameFactory, InjectableFactories, SettingsFactory } from "../../../composition/InjectableFactories";
import { PromiseCompletionSource, SceneManager } from "scene-manager";
import { GameSceneOptions } from "../../game/GameSceneOptions";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { IGameDistributionSdk } from "../../../gamedistribution/interfaces/IGameDistributionSdk";

@injectable()
export class MenuController {
    public constructor(
        private readonly sceneManager: SceneManager,
        @inject(InjectableFactories.SettingsFactory) private readonly settingsFactory: SettingsFactory,
        @inject(InjectableFactories.GameFactory) private readonly gameFactory: GameFactory,
        @inject(InjectableFactories.ForceRotateFactory) private readonly forceRotateFactory: ForceRotateFactory,
        @inject(InjectableInterfaces.IGameDistributionSdk) private readonly gdSdk: IGameDistributionSdk
    ) {
    }

    public async showSettings(): Promise<void> {
        const scene = await this.settingsFactory();
        await this.sceneManager.showViewableAsync(scene);
    }

    public async showGame(operationControls: PromiseCompletionSource<void>) {
        await this.gdSdk.showPrerollAd();
        const initialGameSceneOptions: GameSceneOptions = { initialHousesRotation: 0 };
        const scene = await this.gameFactory(initialGameSceneOptions);
        operationControls.complete();
        await this.sceneManager.showViewableAsync(scene);
    }

    public async showForceRotatePopup(): Promise<void> {
        const scene = await this.forceRotateFactory();
        await this.sceneManager.showViewableAsync(scene);
    }
}
